import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import "./custom-bootstrap.scss";
import "./assets/css/index.scss";
import "react-datepicker/dist/react-datepicker.css";
import "./i18n";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import { StrictMode } from 'react';
import { APP_VERSION } from './version';
import { PostHogProvider } from '@posthog/react';

console.log('🚀 App version:', APP_VERSION);

const POSTHOG_LEADER_KEY = 'posthog_leader_tab';

(function setPostHogLeader() {
  try {
    if (!localStorage.getItem(POSTHOG_LEADER_KEY)) {
      const tabId = Date.now() + '-' + Math.random().toString(36).slice(2);
      localStorage.setItem(POSTHOG_LEADER_KEY, tabId);
      (window as any).__POSTHOG_LEADER__ = true;
      (window as any).__POSTHOG_LEADER_ID__ = tabId;
      window.addEventListener('beforeunload', () => {
        if (localStorage.getItem(POSTHOG_LEADER_KEY) === tabId) {
          localStorage.removeItem(POSTHOG_LEADER_KEY);
        }
      });
    } else {
      (window as any).__POSTHOG_LEADER__ = false;
      window.addEventListener('storage', (e: StorageEvent) => {
        if (e.key === POSTHOG_LEADER_KEY && e.oldValue != null && e.newValue == null) {
          window.location.reload();
        }
      });
    }
  } catch (_) {
    (window as any).__POSTHOG_LEADER__ = true;
  }
})();

const storedVersion = localStorage.getItem('app_version');
if (storedVersion !== APP_VERSION) {
  localStorage.setItem('app_version', APP_VERSION);
  console.log('🧹 New version detected → reloading');
  // clear cookies
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    document.cookie = `${name}=${value}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  }

  window.location.reload();
}


const posthogOptions = {
    api_host: 'https://ch.emailwish.com',
    defaults: '2026-01-30' as const,
    capture_pageview: false,
    capture_pageleave: false,
    persistence: 'sessionStorage' as const,
    rate_limiting: { events_per_second: 2, events_burst_limit: 10 },
    // Allow the session-replay recorder script to load; keep flags off.
    disable_external_dependency_loading: false,
    disable_session_recording: false,
    advanced_disable_feature_flags: true,
};

const isPostHogLeader = !!(window as any).__POSTHOG_LEADER__;

const app = (
    <StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </StrictMode>
);

const appWithPostHog = (
    <StrictMode>
        <PostHogProvider apiKey="phc_Crt0iNRAIpVoCz2W3fwDEFyWolwVY0nEcgiVk5bCLgg" options={posthogOptions}>
            <Provider store={store}>
                <App />
            </Provider>
        </PostHogProvider>
    </StrictMode>
);

ReactDOM.render(isPostHogLeader ? appWithPostHog : app, document.getElementById('root'));
serviceWorkerRegistration.unregister();

